import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-patients-faq',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './patients-faq.component.html',
  styleUrl: './patients-faq.component.scss'
})
export class PatientsFaqComponent {

  faqs = [
    {
      q:"Why can’t my provider just give me a reduced rate without joining FHAdvantage?",
      a:"In many states, legal issues prevent providers from lowering their rates. FHAdvantage, allows them to offer their fees at a discounted rate."
    },
    {
      q:"How much of a discount will my family and I receive?",
      a:"Discounts vary by provider, but typically patients can recoup their FHAdvantage annual fee on the first visit."
    },
    {
      q:"Can I join if I have insurance?",
      a:"Of course, however, it may only be used for services that are not being covered by insurance or Medicare."
    },
    {
      q:"What if my insurance covers part of the services?",
      a:"Patients are free to use their insurance benefits until they are exhausted and then use FHAdvantage for the remainder of year."
    },
    {
      q:"Is there a limit to the number of services my family can receive?",
      a:"FHAdvantage is unlimited coverage for the entire family if your provider is in our network."
    },
    {
      q:"Can I pay for my membership with my FSA or HSA card?",
      a:"We recommend using your regular credit or debit card. FHAdvantage charges are typically declined by FSA/HSA."
    },
    {
      q:"Where can I get a replacement membership card?",
      a:"FHAdvantage is completely digital. Instructions on how to download membership cards can be found when you log into the patient portal. If you don’t have your card, providers can also look in the Provider Portal for active members."
    },
    {
      q:"Why aren’t my family members listed on my digital card?",
      a:"Dependent information can be seen by patients and providers once logging into FHAdvantage."
    },
    {
      q:"Does my membership automatically renew?",
      a:"Yes, memberships will automatically renew on the date of purchase. Patients will need to cancel their membership inside the Patient Portal."
    },
    {
      q:"What if my provider is not listed in the Provider Directory?",
      a:"If your provider is not listed in the directory, <a class='text-center text-black d-block' href='/contact'>click here</a> to submit the provider’s information and FHAdvantage will reach out to them about joining the network."
    }
  ];
  q = "Why can’t my provider just give me a reduced rate without joining FHAdvantage?";
  a = "In many states, legal issues prevent providers from lowering their rates. FHAdvantage, allows them to offer their fees at a discounted rate.";
}
